import React from "react";

const testimonials = [
  {
    quote: "IBH simplified everything we were juggling — GST, hiring, even our seed round. The L2 experts are gold.",
    rating: 5,
  },
  {
    quote: "The WhatsApp helpline is brilliant. We get answers in minutes — no scheduling, no consultants billing hours.",
    rating: 4,
  },
  {
    quote: "From compliance to investor intros, IBH has been our growth co-pilot. ₹1.8Cr raised with their network.",
    rating: 5,
  },
];

const Testimonials = () => {
  return (
    <section
      className="py-20 sm:py-28 bg-white"
      data-testid="testimonials-section"
    >
      <div className="section">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="chip">
              <i className="fa-solid fa-quote-left text-ibh-orange"></i>
              Loved by founders
            </span>
            <h2 className="mt-4 font-display text-3xl sm:text-5xl font-bold text-slate-900 leading-tight">
              Real businesses.<br />
              <span className="gradient-text">Real outcomes.</span>
            </h2>
          </div>

          {/* Top right 4.5 stars */}
          <div className="flex items-center gap-2">
            {[1, 2, 3, 4].map((s) => (
              <i key={s} className="fa-solid fa-star text-amber-400 text-lg"></i>
            ))}
            <i className="fa-solid fa-star-half-stroke text-amber-400 text-lg"></i>
            <span className="ml-2 text-sm text-slate-600">
              4.9/5 
            </span>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative rounded-3xl bg-gradient-to-b from-white to-slate-50 border border-slate-200/70 p-7 card-hover"
            >
              {/* Per-card dynamic stars */}
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: Math.floor(t.rating) }).map((_, idx) => (
                  <i key={idx} className="fa-solid fa-star text-amber-400 text-sm"></i>
                ))}
                {t.rating % 1 !== 0 && (
                  <i className="fa-solid fa-star-half-stroke text-amber-400 text-sm"></i>
                )}
                {Array.from({ length: 5 - Math.ceil(t.rating) }).map((_, idx) => (
                  <i key={`empty-${idx}`} className="fa-regular fa-star text-amber-400 text-sm"></i>
                ))}
              </div>

              <p className="text-slate-700 leading-relaxed">"{t.quote}"</p>

              <div className="mt-7 flex items-center gap-3">
                <div
                  className={`h-11 w-11 rounded-full bg-gradient-to-br ${t.color} flex items-center justify-center text-white font-display font-bold text-lg`}
                >
                  {t.initial}
                </div>
                <div>
                  <p className="font-display font-bold text-slate-900 text-sm">
                    {t.name}
                  </p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
              </div>

              <i className="fa-solid fa-quote-right absolute top-6 right-6 text-slate-100 text-3xl"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
